import {Slider} from "@/components/ui/slider.tsx";
import {ArrowRight} from "lucide-react";
import {Badge} from "@/components/ui/badge.tsx";
import TorzsgardaGraph from "@/components/editor/TorzsgardaGraph.tsx";
import {Button} from "@/components/ui/button.tsx";
import {useEffect, useState} from "react";
import torzsgarda from "@/assets/editor/torzsgarda.svg"
import axios from "axios";

export type TorzsgardaCalc = {
    lojalitas: {
        befizetes: number[],
        kifizetes: number[],
        netto: number[],
        ado: number[],
        cegben_marad: number[],
        true_ado: number[],
    },
    torzsgarda: {
        befizetes: number[],
        kifizetes: number[],
        netto: number[],
        ado: number[],
        cegben_marad: number[],
        true_ado: number[],
    },
    torzsgarda_ber: {
        befizetes: number[],
        kifizetes: number[],
        netto: number[],
        ado: number[],
        cegben_marad: number[],
        true_ado: number[],
    }
}

export default function TorzsgardaDetails({
                                              onClose, values
                                          }: { onClose: () => void, values: any }) {
    const [selectedGraph, setSelectedGraph] = useState<"input" | "tax">("input");
    const [year, setYear] = useState(10);
    const maxYears = 10;
    const [calc, setCalc] = useState<TorzsgardaCalc | null>(null);

    const currency = values?.value?.valuta == "HUF" ? "Ft" : "€"

    useEffect(() => {
        axios.post('/api/torzsgarda', values).then((res) => {
            console.log(res.data)
            setCalc(res.data)
        })
    }, [values])

    return <div className={"flex flex-col grow gap-4 items-center"}>
        <div className={"w-1/2 relative mt-4"}>
            <div className={"w-full relative"}>
                <p className={`w-12 bottom-0 absolute text-center -translate-x-1/2 -translate-y-1/2 text-primary font-medium`}
                   style={{left: year / maxYears * 100 + "%"}}>{year} év</p>
            </div>
            <Slider max={maxYears} value={[year]} onValueChange={(v) => setYear(v[0])} min={0}/>
        </div>
        <div className={"flex gap-12 items-center justify-center w-full"}>
            <div className={"w-1/4"}>
                <p className={"text-lg"}>Hagyományos rendszer alapján</p>
                <p className={"text-gray-500"}>Nettó <p
                    className={"text-primary inline"}>{(values?.value?.value ?? 0).toLocaleString("hu-HU")} Ft</p>
                </p>
                <p className={"text-gray-500"}>Adó <p
                    className={"text-primary inline"}>{(69.924).toLocaleString("hu-HU")} %</p>
                </p>
                <p className={"text-gray-500"}>Befizetés <p
                    className={"text-primary inline"}>{(calc?.lojalitas.befizetes[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                </p>
                <p className={"text-gray-500"}>Hozammal növelt <p
                    className={"text-primary inline"}>{(calc?.lojalitas.kifizetes[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                </p>
                <p className={"text-gray-500"}>Nettója <p
                    className={"text-primary inline"}>{(calc?.lojalitas.netto[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                </p>
                <p className={"text-gray-500"}>Cégben marad <p
                    className={"text-primary inline"}>{(calc?.lojalitas.cegben_marad[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                </p>
            </div>
            <ArrowRight/>
            <div className={"bg-primary text-white rounded-xl p-4 w-1/4 flex items-start"}>
                <div className={"grow"}>
                    <p className={"text-xl font-bold"}>Új rendszer alapján</p>
                    <p>Nettó {(values?.value?.value ?? 0).toLocaleString("hu-HU")} {currency}</p>
                    <p>Adó {(33.04).toLocaleString("hu-HU")} %</p>
                    <p>Befizetés {(calc?.torzsgarda.befizetes[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                    <p>Hozammal
                        növelt {(calc?.torzsgarda.kifizetes[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                    <p>Nettója {(calc?.torzsgarda.netto[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                    <p>Cégben marad {(calc?.torzsgarda.cegben_marad[year - 1] ?? 0).toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}</p>
                </div>
                <img alt={"Törzsgárda program ikon"} className={"w-20"} src={torzsgarda}/>
            </div>
        </div>
        <div className={"w-full grow"}>
            <div className={"flex items-center justify-center gap-2 mb-4"}>
                <Badge onClick={() => setSelectedGraph("input")} className={"cursor-pointer"}
                       variant={selectedGraph != "input" ? "outline" : "default"}>Befizetés</Badge>
                <Badge onClick={() => setSelectedGraph("tax")} className={"cursor-pointer"}
                       variant={selectedGraph != "tax" ? "outline" : "default"}>Adó</Badge>
                <div className={"text-primary"}>
                    Különbség:
                    <p className={`ml-1 inline ${year < 4 ? "text-black" : (year < 8 ? "text-primary" : "text-destructive")}`}>
                        {
                            (()=>{
                                switch (selectedGraph) {
                                    case "tax":
                                        return (calc?.lojalitas.cegben_marad[year - 1] ?? 0) - (calc?.torzsgarda.cegben_marad[year - 1] ?? 0)
                                    case 'input':
                                        return (calc?.lojalitas.befizetes[year - 1] ?? 0) - (calc?.torzsgarda.befizetes[year - 1] ?? 0)
                                }
                            })().toLocaleString("hu-HU", {maximumFractionDigits: 0})} {currency}
                    </p>
                </div>
            </div>
            <div className={"w-full mb-8"}
                 style={{height: "calc(30vh - mod(30vh, 50px) + 1px)"}}>
                <TorzsgardaGraph currency={currency} graph={selectedGraph} year={year} calc={calc} setYear={setYear}/>
            </div>
        </div>
        <div className={"w-full flex justify-end"}>
            <Button onClick={() => onClose()}>
                Mentés
            </Button>
        </div>
    </div>;
}